<template>
  <div class="home-index">
    <div class="container">
      <div v-if="!isLogin" class="center-left">
        <div class="login-box">
          <div class="avatar">
            <img src="@/assets/avatar.jpeg" alt="头像">
          </div>
          <div class="user-desc">
            <span><a href="/login">立即登录</a></span>
            <span><a href="#">注册</a></span>
          </div>
        </div>
        <!-- 如果没有登录就显示简介详情，登录后就显示功能按钮 -->
        <div class="desc">
          <span>吃掉那只青蛙</span>
          <span>本网站域名来自《吃掉那只青蛙》，希望我们每个人都克服拖延的坏毛病。</span>
          <span>{{ currentTime }}</span>
          <span>道阻且长，行则将至</span>
          <span>待到风起时，苦赴倒悬山</span>
        </div>
      </div>
      <div v-else class="center-left">
        <div class="login-box">
          <div class="avatar">
            <img src="@/assets/avatar.jpeg" alt="头像">
          </div>
          <div class="user-desc">
            <span>{{ userid }}</span>
            <span class="logoutBtn" @click="logout">退出登录</span>
          </div>
        </div>
        <div class="menu noselect">
          <span>
            <RouterLink :to="{name: 'homehome'}">
              主页
            </RouterLink>
          </span>
          <span>
            <RouterLink :to="{name: 'article'}">
              文章
            </RouterLink>
          </span>
          <span>
            <RouterLink :to="{name: 'write'}">
              写作
            </RouterLink>
          </span>
          <span>
            <RouterLink :to="{name: 'plan'}">
              计划
            </RouterLink>
          </span>
          <span><a href="#">个人中心</a></span>
        </div>
      </div>
      <RouterView/>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted } from 'vue'
import Cookies from 'js-cookie'
import getCurrentTime from '@/utils/getCurrentTime'
import { useRouter } from 'vue-router'

export default {
  name: 'HomeIndex',
  setup () {
    let timer = null
    const currentTime = ref(getCurrentTime())

    const isLogin = ref(false)
    const userid = ref(undefined)

    const router = useRouter()

    const logout = () => {
      Cookies.remove('userid', { path: '/' })
      Cookies.remove('usertoken', { path: '/' })
      isLogin.value = false

      // 同时跳转到首页
      router.push({
        name: 'homehome'
      })
    }

    onMounted(() => {
      // 获取cookie中的userid，如果存在就展示已经登录的页面，如果不存在就展示首页
      userid.value = Cookies.get('userid')
      console.log('userid', userid.value)
      if (userid.value !== undefined) {
        isLogin.value = true
      }
      timer = setInterval(() => { currentTime.value = getCurrentTime() }, 1000)
    })

    onUnmounted(() => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    })
    // // 全部数据在父节点请求，并使用provide和inject注入
    // const doneLoading = () => {
    //   loading.value = false
    // }
    // provide('doneLoading', doneLoading)
    return {
      isLogin,
      currentTime,
      userid,
      logout
    }
  }
}
</script>

<style lang="less" scoped>
.home-index {
  // scrollbar-color: rgb(226, 226, 226) ;
  background-color: @backgroundColor;
  // background-color: rgb(245, 242, 240);
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
}

.container {
  display: flex;
  gap: 2;
  align-items: flex-start;
  .center-left {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    flex: 0 0 240px;
    position:sticky;
    top: 0;
    // background-color: rebeccapurple;
    // opacity: 30%;
    // height: 80vh;
    max-height: 100vh;

    @media (max-width: 768px) {
      display: none;
    }
    .login-box {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      // background-color: rgb(255, 255, 255);
      padding: 50px 0;
      .login-avatar {
        margin: 0 auto;
      }
      .avatar {
        margin: 0 auto;
        border: 5px double;
        border-radius: 15px;
        height: 70px;
        width: 70px;
        img {
          height: 60px;
          width: 60px;
          object-fit: cover;
          border-radius: 10px;
        }
      }
      .user-desc {
        margin: 0 auto;
        display: flex;
        column-gap: 10px;
      }
      .logoutBtn {
        cursor: pointer;
      }
    }
    .menu {
      display: flex;
      flex-direction: column;
      gap: 40px;
      margin-top: 20px;
      span {
        text-align: center;
      }
    }
    .desc {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      padding: 20px;
      border-radius: 15px;
      // background-color: rgb(255, 255, 255);
      span {
        // border-bottom: 1px solid rgb(155, 155, 155);
        padding-bottom: 10px;
        text-align: center;
      }
      span:last-child {
        border-bottom: 0px;
      }
    }
  }
}

</style>>
